module.exports = __webpack_public_path__ + "img/shape-6-mobile-gold@2x.786805c6.png";